import { render, staticRenderFns } from "./BoisType.vue?vue&type=template&id=1caa8bb8&"
import script from "./BoisType.vue?vue&type=script&lang=ts&"
export * from "./BoisType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports